export const COMPANY_CODE_POST_MESSAGE = 'ci_zlabo';
export const DOMAIN_POST_MESSAGE = 'https://www.ci-z.com';
